import React from 'react';
import QuestionSingleSelector from '../components/QuestionSingleSelector';
import {SingleSelectorQuestion} from '../types/question';

const QuestionElevenChargingHome = (props: SingleSelectorQuestion) => {
  const {title, singleSelectOptions} = props;
  return (
    <QuestionSingleSelector
      title={title || ''}
      singleSelectOptions={singleSelectOptions}
    />
  );
};

export default QuestionElevenChargingHome;
